module.exports = __webpack_public_path__ + "img/8.b1d3cb88.jpg";